import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import "./Accordion.scss"; // optional styling
import AssignsymbolPopup from "./AssignsymbolPopup";
import CustomModal from "../CustomModal";
import "../AssignSymbols/assignSymbols.scss";
import ValueContext from "../../utils/contextAPI/contextAPI";
import sixDotIcon from "../../images/6doticon.svg";
import DraggableItem from "../LeftContentPanel/DraggableItem";
import {
  isMatchVariantGroupUsedOnEditor,
  matchVariantGroupHasContent,
  isSlicePlacedOnEditor,
  getSymbolForRelatedInModule,
  normRelatedId,
  cssQuotedAttr,
} from "../../utils/editorUtils/claimEditorUsage";

const AccordionItem = ({
  title,
  content,
  isOpen,
  onClick,
  claim,
  editor,
  customDrag,
  setClaimsOnEditorAsset,
  claimsOnEditorAsset,
  moduleClaimsData,
  item,
  setRelatedClaimsData,
  relatedClaimsData,
  assignedSymbols,
  setPreviewLoading,
  setAssignedSymbols,
  previewLoading,
  displayFor,
  mustUseFlag,
  hideUsedOnLHS,
}) => {
  const appData = useContext(ValueContext);

  const parentKey = claim.claimName || claim.componentDocNumber;
  const moduleDam = moduleClaimsData?.moduleDamName;
  /** Same segment as claimEditorUsage / canvas data-content-id for related reusable text */
  const relatedSliceKey = normRelatedId(
    item.claimName || item.reusableTextName || "",
  );

  const [OpenAssignPopup, setOpenAssignPopup] = useState(false);
  const [appliedSymbol, setAppledSymbol] = useState(null);
  const [condition, setCondition] = useState(false); // added to re-render
  const footnoteSymbols = [
    "*",
    "†",
    "€",
    "¶",
    "§",
    "#",
    "@",
    "$",
    "!",
    "‡",
    "||",
    "µ",
    "¥",
    "^",
    "~",
    "**",
    "***",
    "£",
    "▼",
    "△",
    "®",
    //"╪",
    "ǂ",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
  ];
  const exceptionSymbols = ["*", "**", "***"];
  const obj = {
    relatedClaimId: relatedSliceKey,
    claimId: parentKey,
    moduleId: moduleDam,
  };

  useEffect(() => {
    const claimExistArray = relatedClaimsData?.findIndex(
      (exist_claim) =>
        normRelatedId(exist_claim.relatedClaimId) === relatedSliceKey &&
        normRelatedId(exist_claim.moduleId) === normRelatedId(moduleDam),
    );
    if (claimExistArray > -1 && relatedClaimsData.length > 0) {
      const symb = relatedClaimsData[claimExistArray]?.symbol;
      displayFor !== "comp" ? setAppledSymbol(symb) : setAppledSymbol("NA");
    }
  }, [appliedSymbol]);

  useEffect(() => {
    if (displayFor === "comp") {
      setAppledSymbol("NA");
      return;
    }
    const symb =
      getSymbolForRelatedInModule(assignedSymbols, moduleDam, relatedSliceKey) ??
      getSymbolForRelatedInModule(relatedClaimsData, moduleDam, relatedSliceKey);
    if (symb != null && symb !== "") {
      setAppledSymbol(symb);
    } else if (assignedSymbols !== null) {
      setAppledSymbol(null);
    }
  }, [assignedSymbols, relatedClaimsData, moduleDam, relatedSliceKey, displayFor]);

  const symbolAssigned = (symbol) => {
    setAppledSymbol(symbol);
  };
  const cancelPopup = () => {
    setOpenAssignPopup(false);
  };

  /** True = already on slide → treat like isDraggable legacy (block drag / gray). */
  const isDraggable = (claimContent, componentId, moduleId) =>
    isSlicePlacedOnEditor(
      editor,
      appData?.deckId?.selected_module_data,
      moduleId,
      componentId,
      claimContent,
    );

  const relatedClaimAdded = (claimId) => {
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps && claimId) {
        const claimRelatedOnEditor = allComps?.find(
          cssQuotedAttr("related-claim", claimId),
        );
        return claimRelatedOnEditor?.length > 0 ? true : false;
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  };

  const matchGroupUsed = isMatchVariantGroupUsedOnEditor(
    editor,
    moduleDam,
    parentKey,
    relatedSliceKey,
    item,
  );
  const matchGroupDragLock = relatedClaimAdded(title) || matchGroupUsed;

  const parentClaimAdded = (claimId) => {
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps && claimId) {
        const claimParentOnEditor = allComps?.find(
          cssQuotedAttr("parent-claim", claimId),
        );
        return claimParentOnEditor?.length > 0 ? true : false;
      } else {
        /* if (displayFor === "comp") {
          return true;
        } */
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  };

  const grayout = (claimMatchText) => {
    const decodedString = new DOMParser().parseFromString(
      editor?.getHtml(),
      "text/html",
    ).documentElement.textContent;
    return decodedString
      .replace(/\s+/g, "")
      .includes(claimMatchText?.replace(/\s+/g, ""));
  };

  const dragMatch = (e, from) => {
    const root = e.currentTarget || e.target;
    const finish = () => {
      e.dataTransfer.effectAllowed = "copyMove";
      if (typeof customDrag === "function") {
        customDrag(e);
      } else {
        const ghost = (e.nativeEvent && e.nativeEvent.srcElement) || root;
        try {
          e.dataTransfer.setDragImage(ghost, 0, 0);
        } catch (_) {}
      }
    };

    if (from === "footnotes") {
      const plain = root.innerText || "";
      e.dataTransfer.setData("text", plain);
      e.dataTransfer.setData("text/plain", plain);
      finish();
      return;
    }
    if (from === "ref") {
      const el = e.currentTarget;
      const clone = el.cloneNode(true);
      clone.querySelector("span")?.remove();
      const lastEl = clone.lastChild;
      lastEl?.querySelector("span")?.remove();
      const html = lastEl?.innerHTML ?? "";
      e.dataTransfer.setData("text/html", html);
      const plain = lastEl?.textContent?.trim() || root.innerText?.trim() || "";
      e.dataTransfer.setData("text/plain", plain);
      e.dataTransfer.setData("text", plain);
      finish();
      return;
    }
    const textVariant = root?.querySelector?.(".textvariant");
    const html = textVariant?.innerHTML ?? root?.lastElementChild?.innerHTML ?? "";
    e.dataTransfer.setData("text/html", html);
    const plain = root.innerText?.trim() || "";
    e.dataTransfer.setData("text/plain", plain);
    e.dataTransfer.setData("text", plain);
    finish();
  };

  editor?.on("component:add", function (elem) {
    setCondition(!condition);
    const claimId = claim.claimName;
    if (!elem.getAttributes()["related-claim"]) return;

    //if it is parent claim
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps) {
        // Keep editable: true so toolbar appears, but prevent content editing via contenteditable and event handlers
        elem.set({
          editable: true, // Keep editable so inline toolbar can appear
          selectable: true, // Allows selection for styling via inline toolbar
        });
        
        // Note: Event handlers for preventing text input will be set up in rte:enable handler
        // This allows the toolbar to work properly while still preventing content editing
        
        const claimParentOnEditor = allComps?.find(
          cssQuotedAttr("parent-claim", claim.claimName),
        );
        let symbolElements = "";
        for (var i = 0; i < claimParentOnEditor.length; i++) {
          symbolElements = claimParentOnEditor[i]?.find("sup");
        }

        if (symbolElements.length > 0) {
          symbolElements.forEach((symbolElement) => {
            if (
              elem.getAttributes()["related-claim"] ===
              symbolElement.getAttributes()["claim-id"]
            )
              symbolElement.setStyle(
                { display: "inline-block !important" },
                { avoidStore: false },
              );
            symbolElement.addAttributes({ contenteditable: "false" });
            symbolElement.set({
              editable: false,
              selectable: true,
              draggable: false,
              droppable: false,
              removable: false,
              copyable: false,
              removable: false,
            });
          });
        }
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  }); // added to re-render whole content in lhs while dropping/removing the text from editor

  editor.on("component:remove", (component) => {
    if (!component.getAttributes()["related-claim"]) return;
    const claimId = claim.claimName;
    const parent = component.parent();
    if (!parent || parent.is("wrapper")) return;

    //parent.remove();
    setCondition(!condition);
  });

  editor?.on("component:remove:before", function (elem) {
    setClaimsOnEditorAsset(!claimsOnEditorAsset);
    if (!elem.getAttributes()["related-claim"]) return;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    const claimParentOnEditor = allComps?.find(
      cssQuotedAttr("parent-claim", claim.claimName),
    );
    let symbolElements = "";
    for (var i = 0; i < claimParentOnEditor.length; i++) {
      symbolElements = claimParentOnEditor[i]?.find("sup");
      claimParentOnEditor[i].set({ editable: true });
    }

    if (symbolElements.length > 0) {
      symbolElements.forEach((symbolElement) => {
        if (
          elem.getAttributes()["related-claim"] ===
          symbolElement.getAttributes()["claim-id"]
        )
          symbolElement.setStyle({ display: "none" }, { avoidStore: false });
      });
    }

    for (var i = 0; i < claimParentOnEditor.length; i++) {
      claimParentOnEditor[i].set({ editable: false });
    }
  });
  return (
    <div className="accordion-item">
      <button className="accordion-header" onClick={onClick}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "18px", // 👈 fixed width for icon so it doesn't change size
              display: "inline-block",
              textAlign: "center",
              backgroundColor: isOpen ? "#F0F5F8" : "",
              color: isOpen ? "#203662" : "",
              fontSize: isOpen ? "14px" : "18px",
              fontWeight: isOpen ? "100" : "",
              cursor: "pointer",
              lineHeight: isOpen ? 1.3 : 1,
              height: "18px",
              borderRadius: "4px",
            }}
          >
            {isOpen ? (
              <span className="minusIcon22">−</span>
            ) : (
              <span className="plusIcon22">+</span>
            )}{" "}
          </div>
          <span
            style={{
              fontSize: "12px",
              marginLeft: "6px",
            }}
          >
            {title}
          </span>

          {item && (
            <div
              className="parentModulebox"
              style={{
                backgroundColor: mustUseFlag === true ? "#E32B35" : "#378A05",
                marginLeft: "10px",
              }}
            ></div>
          )}
        </div>
        <div
          className="edit-claim-block"
          onClick={(e) => {
            e.stopPropagation();
            setOpenAssignPopup(true);
          }}
        >
          {appliedSymbol !== null && displayFor !== "comp" && (
            <div
              className={`symbol-icon`}
              style={{
                fontSize: exceptionSymbols.includes(appliedSymbol)
                  ? "15px"
                  : "11px",
                fontFamily: [
                  "I",
                  "II",
                  "III",
                  "IV",
                  "V",
                  "VI",
                  "VII",
                  "VIII",
                  "IX",
                  "X",
                ].includes(appliedSymbol)
                  ? `"Times New Roman', serif"`
                  : `"Nunito Sans", sans-serif`,
              }}
            >
              {appliedSymbol}
            </div>
            /*  <div className={`symbol-icon`} style={{fontSize : exceptionSymbols.includes(appliedSymbol)?'15px':'11px'}}>{appliedSymbol}</div> */
          )}

          {/*            {appliedSymbol !== null && <div className={`symbol-icon`}>{assignedSymbols?.filter((id) => id.relatedClaimId === title)[0]?.symbol.trim() || appliedSymbol !== null && appliedSymbol}</div>}
           */}
          {displayFor !== "comp" && (
            <div>{appliedSymbol !== null ? "Edit" : "Assign Claim"} symbol</div>
          )}
        </div>
      </button>
      {isOpen && (
        <div
          className={`accordion-content ${
            !parentClaimAdded(
              displayFor === "comp"
                ? claim.componentDocNumber
                : claim.claimName,
            )
              ? "restrict_section"
              : "falseclass"
          }`}
        >
          {/* start — match text + variants share one "used on editor" group */}
          {matchVariantGroupHasContent(item) &&
            (!hideUsedOnLHS || !matchGroupUsed) && (
              <>
                {item.matchText && (
                  <>
                    <div className="matchText showContent_OnEditor">
                      Match Text{" "}
                    </div>
                    <div
                      className={`draggableText 
              ${
                !appData.deckId.contentOnEditorToggle ||
                !matchGroupDragLock
                  ? "d-flex"
                  : ""
              }
                  showContent_OnEditor
                   ${
                     appliedSymbol == null || matchGroupDragLock
                       ? "grayOut"
                       : ""
                   }`}
                      draggable={
                        appliedSymbol !== null && !matchGroupDragLock
                      }
                      onDragStart={(e) => dragMatch(e, `${moduleDam}-${parentKey}-${relatedSliceKey}-matchText` )}
                      onDragEnd={(e) => {
                        setClaimsOnEditorAsset(!claimsOnEditorAsset);
                        setCondition(
                          appliedSymbol == null || isDraggable(item.matchText),
                        );
                      }}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      <img
                        src={sixDotIcon}
                        alt=""
                        className="img-fluid sixdotIcon"
                      />
                      <div className="textvariant">
                        <div
                          module-claim={moduleClaimsData?.moduleDamName}
                          related-claim={title}
                          related-claim-comp={
                            displayFor === "comp"
                              ? claim.componentDocNumber
                              : ""
                          }
                          className="parent-claim"
                          data-content-id={`${moduleDam}-${parentKey}-${relatedSliceKey}-matchText`}
                        >
                          {displayFor !== "comp" && (
                            <sup
                              className="hide-Lhs-sup test"
                              claim-id={title}
                              contentEditable="false"
                              style={{ userSelect: "none" }}
                            >
                              {appliedSymbol}
                            </sup>
                          )}
                          {item.matchText}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {item.matchTextVariants?.map((content, index) => {
                  const variantContentId = `${moduleDam}-${parentKey}-${relatedSliceKey}-variant-${content.id}`;
                  return (
                    <React.Fragment key={content.id ?? index}>
                      <div className="matchText showContent_OnEditor">{`Match Text Variant ${index + 1}`}</div>
                      <div
                        className={`draggableText
                      ${
                        !appData.deckId.contentOnEditorToggle ||
                        !matchGroupDragLock
                          ? "d-flex"
                          : ""
                      }
                  showContent_OnEditor
                      ${
                        appliedSymbol == null || matchGroupDragLock
                          ? "grayOut"
                          : ""
                      }`}
                        draggable={
                          appliedSymbol !== null && !matchGroupDragLock
                        }
                        onDragStart={(e) => dragMatch(e)}
                        onDragEnd={(e) => {
                          setClaimsOnEditorAsset(!claimsOnEditorAsset);
                          setCondition(
                            appliedSymbol == null ||
                              isDraggable(content.matchText),
                          );
                        }}
                        onDragOver={(e) => e.preventDefault()}
                      >
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                        <div className="textvariant">
                          {content.matchText && (
                            <div
                              module-claim={moduleClaimsData?.moduleDamName}
                              related-claim={title}
                              className="parent-claim"
                              related-claim-comp={
                                displayFor === "comp"
                                  ? claim.componentDocNumber
                                  : ""
                              }
                              data-content-id={variantContentId}
                            >
                              {displayFor !== "comp" && (
                                <sup
                                  className="hide-Lhs-sup"
                                  claim-id={title}
                                  contentEditable={false}
                                  style={{ userSelect: "none" }}
                                >
                                  {appliedSymbol}
                                </sup>
                              )}
                              {content.matchText}
                            </div>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </>
            )}
          {item.footnotes?.length > 0 &&
            (!hideUsedOnLHS ||
              !isDraggable(
                item.footnotes,
                `${parentKey}-${relatedSliceKey}-footnote`,
                moduleClaimsData?.moduleDamName,
              )) && (
              <div className="matchText1 showContent_OnEditor">
                Footnotes{" "}
              </div>
            )}
          {/* <div
            className={`textvariant1 draggableText 
              ${
                appData.deckId.contentOnEditorToggle &&
                isDraggable(item.footnotes)
                  ? "showContent_OnEditor"
                  : "showContent_OnEditor"
              }
              ${
                appliedSymbol == null || grayout(item.footnotes)
                  ? "grayOut"
                  : ""
              }`}
            draggable={appliedSymbol !== null && !isDraggable(item.footnotes)}
            onDragStart={(e) => dragMatch(e)}
            onDragEnd={(e) => {
              setClaimsOnEditorAsset(!claimsOnEditorAsset);
              setCondition(
                appliedSymbol == null || isDraggable(item.footnotes),
              ); // added to re-render
            }}
          >
            <div className="textvariant1">
              <div
                module-claim={moduleClaimsData?.moduleDamName}
                related-claim-comp={
                  displayFor === "comp" ? claim.componentDocNumber : ""
                }
                className="parent-claim"
                data-content-id={`${moduleClaimsData?.moduleDamName}-${
                  claim.claimName || claim.componentDocNumber
                }-${item.claimName}-footnote`}
              >
                {item.footnotes}
              </div>
            </div>
          </div> */}
          <DraggableItem
            relatedClaimComp={
              displayFor === "comp" ? claim.componentDocNumber : ""
            }
            key={relatedSliceKey}
            content={item.footnotes}
            moduleId={moduleClaimsData?.moduleDamName}
            componentId={`${parentKey}-${relatedSliceKey}-footnote`}
            isUsed={isDraggable(
              item.footnotes,
              `${parentKey}-${relatedSliceKey}-footnote`,
              moduleClaimsData?.moduleDamName,
            )}
            hideIfUsed={hideUsedOnLHS}
            isPlacedOnEditor={isDraggable(
              item.footnotes,
              `${parentKey}-${relatedSliceKey}-footnote`,
              moduleClaimsData?.moduleDamName,
            )}
            dragMatch={dragMatch}
            onDragEndUpdate={() => {
              setClaimsOnEditorAsset(!claimsOnEditorAsset);
              setCondition(isDraggable(item.footnotes));
            }}
          />

          {item.abbreviation?.length > 0 &&
            (!hideUsedOnLHS ||
              item.abbreviation?.split(";").some((raw, abbrIdx) => {
                if (!raw?.trim()) return false;
                return !isDraggable(
                  raw.trim(),
                  `${parentKey}-${relatedSliceKey}-abbreviation-${abbrIdx + 1}`,
                  moduleClaimsData?.moduleDamName,
                );
              })) && <div className="matchText1">Abbreviations</div>}

          {/*abbrevaitions listed as row */}
          {item.abbreviation?.split(";").length > 0 &&
            item.abbreviation?.split(";").map((itemAbb, index) => {
              const value = itemAbb.trim();
              if (!value) return; // skip empty values
              return (
                <>
                  
                  <DraggableItem
                    relatedClaimComp={
                      displayFor === "comp" ? claim.componentDocNumber : ""
                    }
                    key={itemAbb}
                    content={itemAbb}
                    moduleId={moduleClaimsData?.moduleDamName}
                    componentId={`${parentKey}-${relatedSliceKey}-abbreviation-${index + 1}`}
                    isUsed={isDraggable(
                      itemAbb,
                      `${parentKey}-${relatedSliceKey}-abbreviation-${index + 1}`,
                      moduleClaimsData?.moduleDamName,
                    )}
                    hideIfUsed={hideUsedOnLHS}
                    isPlacedOnEditor={isDraggable(
                      itemAbb,
                      `${parentKey}-${relatedSliceKey}-abbreviation-${index + 1}`,
                      moduleClaimsData?.moduleDamName,
                    )}
                    dragMatch={dragMatch}
                    onDragEndUpdate={() => {
                      setClaimsOnEditorAsset(!claimsOnEditorAsset);
                      setCondition(isDraggable(itemAbb));
                    }}
                  />
                </>
              );
            })}
          {/*  */}
          {item.references?.length > 0 &&
            (!hideUsedOnLHS ||
              item.references.some(
                (ref) =>
                  !isDraggable(
                    ref.documentName,
                    `${parentKey}-${relatedSliceKey}-reference-${ref.id}`,
                    moduleClaimsData?.moduleDamName,
                  ),
              )) && <div className="matchText1">References</div>}
          {item.references?.map((cont, index) => {
            return (
              <>
                {/*  <div
                  className={`textvariant1 draggableText 
                     ${
                       appData.deckId.contentOnEditorToggle &&
                       isDraggable(cont.documentName)
                         ? "showContent_OnEditor"
                         : "showContent_OnEditor"
                     }
                    ${
                      appliedSymbol == null || grayout(cont.documentName)
                        ? "grayOut"
                        : ""
                    }`}
                  draggable={
                    appliedSymbol !== null && !isDraggable(cont.documentName)
                  }
                  onDragStart={(e) => dragMatch(e, "ref")}
                  onDragEnd={(e) => {
                    setClaimsOnEditorAsset(!claimsOnEditorAsset);
                    setCondition(
                      appliedSymbol == null || isDraggable(cont.documentName),
                    ); //// added to re-render
                  }}
                >
                  <div className="textvariant1 d-flex">
                    {" "}
                    <span>{index + 1}. </span>
                    <div
                      module-claim={moduleClaimsData?.moduleDamName}
                      related-claim-comp={
                        displayFor === "comp" ? claim.componentDocNumber : ""
                      }
                      className="parent-claim alignText"
                      data-content-id={`${moduleClaimsData?.moduleDamName}-${
                        claim.claimName || claim.componentDocNumber
                      }-${item.claimName}-reference-${cont.id}`}
                    >
                      {`${cont.documentName}`}
                    </div>
                  </div>
                </div> */}
                <DraggableItem
                  relatedClaimComp={
                    displayFor === "comp" ? claim.componentDocNumber : ""
                  }
                  index={index}
                  key={cont.documentName}
                  content={cont.documentName}
                  moduleId={moduleClaimsData?.moduleDamName}
                  componentId={`${parentKey}-${relatedSliceKey}-reference-${cont.id}`}
                  isUsed={isDraggable(
                    cont.documentName,
                    `${parentKey}-${relatedSliceKey}-reference-${cont.id}`,
                    moduleClaimsData?.moduleDamName,
                  )}
                  hideIfUsed={hideUsedOnLHS}
                  isPlacedOnEditor={isDraggable(
                    cont.documentName,
                    `${parentKey}-${relatedSliceKey}-reference-${cont.id}`,
                    moduleClaimsData?.moduleDamName,
                  )}
                  dragMatch={dragMatch}
                  onDragEndUpdate={() =>
                    setClaimsOnEditorAsset(!claimsOnEditorAsset)
                  }
                  sixDotIcon={null} // optional, no icon for references
                  type="ref"
                />
              </>
            );
          })}
          {/* end */}
        </div>
      )}

      {OpenAssignPopup && (
        <CustomModal
          displayModal={OpenAssignPopup}
          hideModal={() => {
            setOpenAssignPopup(false);
          }}
          title={""}
          size="xl"
          dilogClassName="detail-informations-modal assignSymbolModal"
        >
          <AssignsymbolPopup
            OpenAssignPopup={OpenAssignPopup}
            setOpenAssignPopup={setOpenAssignPopup}
            footnoteSymbols={footnoteSymbols}
            symbolAssigned={symbolAssigned}
            cancelPopup={cancelPopup}
            item={item}
            claim={claim}
            moduleClaimsData={moduleClaimsData}
            setAppledSymbol={setAppledSymbol}
            relatedClaimsData={relatedClaimsData}
            setRelatedClaimsData={setRelatedClaimsData}
            setPreviewLoading={setPreviewLoading}
            setAssignedSymbols={setAssignedSymbols}
            editor={editor}
            appliedSymbol={appliedSymbol}
            previewLoading={previewLoading}
          />
        </CustomModal>
      )}
    </div>
  );
};

const AccordionClaim = ({
  relatedClaims,
  claim,
  customDrag,
  setClaimsOnEditorAsset,
  editor,
  claimsOnEditorAsset,
  moduleClaimsData,
  assignedSymbols,
  setAssignedSymbols,
  setPreviewLoading,
  previewLoading,
  displayFor,
  mustUseFlag,
  hideUsedOnLHS = false,
}) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [relatedClaimsData, setRelatedClaimsData] = useState([]);
  const [symbolsObjData, setSymbolsObjData] = useState({});
  const { pageId } = useParams();
  useEffect(() => {
    setRelatedClaimsData(assignedSymbols);
    setPreviewLoading(false);
  }, [assignedSymbols]);
  const handleClick = (index) => {
    // If clicked item is already open, close it; otherwise, open the new one
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div className="accordion">
      {!previewLoading &&
        assignedSymbols !== null &&
        relatedClaimsData !== null &&
        relatedClaims.map((item, index) => (
          <AccordionItem
            key={index}
            title={item.claimName || item.reusableTextName}
            content={item.footnotes}
            isOpen={openIndex === index}
            onClick={() => handleClick(index)}
            claim={claim}
            customDrag={customDrag}
            setClaimsOnEditorAsset={setClaimsOnEditorAsset}
            editor={editor}
            moduleClaimsData={moduleClaimsData}
            item={item}
            relatedClaimsData={relatedClaimsData}
            setRelatedClaimsData={setRelatedClaimsData}
            assignedSymbols={assignedSymbols}
            setPreviewLoading={setPreviewLoading}
            previewLoading={previewLoading}
            setAssignedSymbols={setAssignedSymbols}
            displayFor={displayFor}
            mustUseFlag={mustUseFlag}
            hideUsedOnLHS={hideUsedOnLHS}
          />
        ))}
    </div>
  );
};

export default AccordionClaim;
